import { formatCurrency } from "src/shared/utils/formatCurrency"
import { fmtDay } from "./segmentEngine"
import { InfoTip } from "./SegmentStrip"

/**
 * The engagement's figures above the campaign, ported from the prototype's StatBar.
 *
 * Four stats, label stacked over value, separated by hairlines — not the five-stat inline
 * strip the engagement list uses. The campaign screen states the engagement's position
 * briefly; the list page is where those figures are explained.
 */
export type BudgetStatBarProps = {
  balance: number
  /** Active days left, as the prototype prints it — a bare count, no unit. */
  daysRemaining: string
  /** Countdown to the next cycle, e.g. "17 days", or "—" where there is no dated cycle. */
  nextBillingCycle: string
  engagementSpend: number
  /** Today, as YYYY-MM-DD. Balance is a nightly snapshot, so the figure is dated. */
  today: string
}

export function BudgetStatBar(props: BudgetStatBarProps) {
  const stats: [string, string][] = [
    ["Balance", formatCurrency(props.balance)],
    ["Days Remaining", props.daysRemaining],
    ["Next Billing Cycle", props.nextBillingCycle],
    ["Engagement Spend", formatCurrency(props.engagementSpend)],
  ]

  return (
    <div className="seg-statbar">
      {stats.map(([label, value]) => (
        <div className="seg-statbar__stat" key={label}>
          <div className="seg-statbar__label">{label}</div>
          <div className="seg-statbar__value">{value}</div>
          {/* Balance is last night's snapshot, not a live figure. Undated it invites the
              reading that a spend made today is already in it. */}
          {label === "Balance" && (
            <div className="seg-statbar__asof">
              Refreshed nightly · as of {fmtDay(props.today)}
              <InfoTip info="The engagement's funds from the contract, updated nightly with spend. Changing a spend window does not move this figure." />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
